module.exports = __webpack_public_path__ + "img/pic6.74381c38.png";